export default __webpack_public_path__ + "static/media/first_order_with_gain.e2476fb6.svg";